// Commerce Ace — Hero Parallax
(function() {
  const heroMedia = /** @type {HTMLElement | null} */ (document.querySelector('[data-testid="hero-desktop-image-1"]'));
  if (!heroMedia) return;

  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;
    const speed = 0.4;
    heroMedia.style.transform = `translateY(${scrollY * speed}px)`;
  }, { passive: true });
})();
// Commerce Ace — Hero Lazy Load
document.querySelectorAll('.hero__media').forEach(function (el) {
  var img = /** @type {HTMLImageElement} */ (el);
  if (img.complete) {
    img.classList.add('is-loaded');
  } else {
    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
    });
  }
});